import { helpers } from '@vuelidate/validators'
import { isUUID } from 'validator'

/**
 * Small wrapper around validator.js isUUID to treat empty values as valid.
 */
const isUUIDIfPresent = helpers.withParams(
  { type: 'uuid' },
  (value: string): boolean => {
    // treat empty as valid
    if (!helpers.req(value)) return true

    return isUUID(value, 'all')
  }
)

export { isUUIDIfPresent }
